import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/Header.module.scss'

import { Container, Image, Button, Offcanvas, Dropdown, Nav } from 'react-bootstrap'

import StormcloudButton from './StormcloudButton'
import FeedbackForm from './FeedbackForm'

class Header extends React.Component {

  constructor(props) {
    super(props);
    
    this.state = {
      show_feedback: false,
      show_feedback2: false,
      show_offcanvas: false
    };
    this.isHoveringDropdown = false;
  }

  showFeedback = () => {
    this.setState({ show_feedback: true });
  }
  closeFeedback = () => {
    this.setState({ show_feedback: false });
  }

  showFeedback2 = () => {
    this.setState({ show_feedback2: true });
  }
  closeFeedback2 = () => {
    this.setState({ show_feedback2: false });
  }

  showOffcanvas = () => {
    this.setState({ show_offcanvas: true });
  }
  closeOffcanvas = () => {
    this.setState({ show_offcanvas: false });
  }

  renderMenuItems = (pages) => {
    return pages.map((page, k) => {
      if (page.submenu && page.submenu.length > 0) {
        return (
          <div 
            key={k} 
            className="dropdown d-inline-block position-relative"
            onMouseEnter={() => this.setState({ [`dropdownOpen-${k}`]: true })}
            onMouseLeave={() => setTimeout(() => {
              if (!this.isHoveringDropdown) {
                this.setState({ [`dropdownOpen-${k}`]: false });
              }
            }, 100)}
          >
            <a 
              href={page.href}
              className={`btn btn-link ${page.active ? styles.menu_item_active : styles.menu_item}`}
            >
              {page.name}
            </a>
            
            <div 
              className={`dropdown-menu ${this.state[`dropdownOpen-${k}`] ? 'show' : ''}`}
              style={{
                position: 'absolute',
                top: '100%',
                left: '0',
                zIndex: 1000,
                minWidth: '160px'
              }}
              onMouseEnter={() => {
                this.isHoveringDropdown = true;
              }}
              onMouseLeave={() => {
                this.isHoveringDropdown = false;
                setTimeout(() => {
                  if (!this.isHoveringDropdown) {
                    this.setState({ [`dropdownOpen-${k}`]: false });
                  }
                }, 50);
              }}
            >
              {/* Невидимая область сверху для плавного перехода */}
              <div 
                style={{
                  position: 'absolute',
                  top: '-3px',
                  left: '0',
                  width: '100%',
                  height: '3px',
                  backgroundColor: 'transparent'
                }}
                onMouseEnter={() => this.isHoveringDropdown = true}
              />
              {page.submenu.map((subItem, subKey) => (
                <a 
                  key={subKey} 
                  href={subItem.href}
                  className={`dropdown-item ${subItem.active ? styles.menu_item_active : styles.menu_item} ${styles.menu_item_dropdown}`}
                  onMouseEnter={() => this.isHoveringDropdown = true}
                >
                  {subItem.name}
                </a>
              ))}
            </div>
          </div>
        );
      } else {
        return (
          <a 
            className={page.active ? styles.menu_item_active : styles.menu_item} 
            key={k} 
            href={page.href}
          >
            {page.name}
          </a>
        );
      }
    });
  }

  renderOffcanvasMenuItems = (pages) => {
    return pages.map((page, k) => {
      if (page.submenu && page.submenu.length > 0) {
        return (
          <div key={k} className={styles.offcanvas_menu_section}>
            <div className={page.active ? styles.menu_item_active : styles.menu_item}>
              {page.name}
            </div>
            <div className={styles.submenu}>
              {page.submenu.map((subItem, subKey) => (
                <a
                  key={subKey}
                  href={subItem.href}
                  className={subItem.active ? styles.menu_item_active : styles.menu_item}
                  onClick={this.closeOffcanvas}
                >
                  {subItem.name}
                </a>
              ))}
            </div>
          </div>
        );
      } else {
        return (
          <a
            className={page.active ? styles.menu_item_active : styles.menu_item}
            key={k}
            href={page.href}
            onClick={this.closeOffcanvas}
          >
            {page.name}
          </a>
        );
      }
    });
  }

  render() {

    const { logo, sitename, slogan, adres, phone, sitemail, vklink, youlink, rutubelink, marshrut, assets_path, menu } = this.props,
    { show_feedback, show_feedback2, show_offcanvas } = this.state

    return (
      <>
        <div className={styles.section_zam}></div>
        <div className={styles.section}>
          <div className={styles.line1}>
            <Container className="h-100">
              <div className={styles.line1_content}>
                <a className={styles.logo} href="/">
                  <Image
                    className={styles.logo_img}
                    width={28}
                    height={37}
                    alt={sitename}
                    src={logo}
                  />
                  <div className={styles.sitename}>{sitename}</div>
                </a>
                <div className={styles.sep}></div>
                <div className={styles.slogan}>{slogan}</div>
                <div style={{ flex: 1 }}></div>
                {adres &&
                  <div className={styles.adres}>
                    <Image src={`/${assets_path}/images/adres.svg`} alt="0" width={14} height={14} />
                    <div>
                      <div className={styles.adres_name}>{adres}</div>
                      <a className={styles.adres_link} target='_blank' href={marshrut} rel='nofollow'>Проложить маршрут</a>
                    </div>
                  </div>
                }
                {phone != `` &&
                  <>
                    <div className={styles.sep}></div>
                    <div className={styles.phone}>
                      <Image src={`/${assets_path}/images/phone.svg`} alt="P" width={14} height={14} />
                      <div>
                        <a className={styles.phone_link} href={`tel:${phone.replace(/[^\d+]/g, '')}`} rel='nofollow'>{phone}</a>
                        <a className={styles.phone_sitemail} href={`mailto:${sitemail}`} rel='nofollow'>{sitemail}</a>
                      </div>
                    </div>
                  </>
                }
                <div className={styles.social}>
                  {vklink != `` &&
                    <a href={vklink} target='_blank' rel='nofollow'>
                      <Image src={`/${assets_path}/images/vk.svg`} alt="vk" width={35} height={35} />
                    </a>
                  }
                  {youlink != `` &&
                    <a href={youlink} target='_blank' rel='nofollow'>
                      <Image src={`/${assets_path}/images/you.svg`} alt="you" width={35} height={35} />
                    </a>
                  }
                  {rutubelink != `` &&
                    <a href={rutubelink} target='_blank' rel='nofollow'>
                      <Image src={`/${assets_path}/images/rutube2.svg`} alt="rut" width={35} height={35} />
                    </a>
                  }
                </div>
                <div className={styles.mob_end}>
                  <StormcloudButton
                    text={`Бесплатный замер`}
                    width={160}
                    svg={
                      <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path 
                          d="M4.87516 11.9173H8.12516C10.8335 11.9173 11.9168 10.834 11.9168 8.12565V4.87565C11.9168 2.16732 10.8335 1.08398 8.12516 1.08398H4.87516C2.16683 1.08398 1.0835 2.16732 1.0835 4.87565V8.12565C1.0835 10.834 2.16683 11.9173 4.87516 11.9173Z" 
                          stroke="black" 
                          strokeWidth="0.8" 
                          strokeLinecap="round" 
                          strokeLinejoin="round"
                        />
                        <path 
                          d="M9.75 3.25L3.25 9.75" 
                          stroke="black" 
                          strokeWidth="0.8" 
                          strokeLinecap="round" 
                          strokeLinejoin="round"
                        />
                        <path 
                          d="M9.75016 5.41667V3.25H7.5835" 
                          stroke="black" 
                          strokeWidth="0.8" 
                          strokeLinecap="round" 
                          strokeLinejoin="round"
                        />
                        <path 
                          d="M3.25 7.58398V9.75065H5.41667" 
                          stroke="black" 
                          strokeWidth="0.8" 
                          strokeLinecap="round" 
                          strokeLinejoin="round"
                        />
                      </svg>
                    }
                    className={styles.zamer}
                    action={() => { this.showFeedback() }}
                  />
                  <FeedbackForm
                    title={`Заказать бесплатный замер`}
                    text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
                    btn={`Отправить`}
                    data={[]}
                    show={show_feedback}
                    handleClose={() => this.closeFeedback()}
                  />

                  {rutubelink != `` &&
                    <a className='d-xl-none' href={rutubelink} target='_blank' rel='nofollow'>
                      <Image src={`/${assets_path}/images/rutube2.svg`} alt="rut" width={35} height={35} />
                    </a>
                  }

                  <div className={styles.mobmenu_btn} onClick={this.showOffcanvas}>
                    <svg width="13" height="9" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 0.726562H12" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M1 4.36328H8.33333" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M1 8H12" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>
              </div>
            </Container>
          </div>
          <div className={styles.line2}>
            <Container className="h-100">
              <div className={styles.line2_content}>
                <div className={styles.menu}>
                  {this.renderMenuItems(menu)}
                </div>
                <Button as={`div`} onClick={() => { this.showFeedback2() }} variant='light' className={styles.zvonok}>
                  <div className={styles.zvonok_icon}>
                    <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.09082 7.90998L7.909 1.0918M7.909 1.0918H2.45446M7.909 1.0918V6.54634" strokeLinecap="round"/>
                    </svg>
                  </div>
                  <div>Заказать звонок</div>
                </Button>
                <FeedbackForm
                  title={`Заказать звонок`}
                  text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
                  btn={`Отправить`}
                  data={[]}
                  show={show_feedback2}
                  handleClose={() => this.closeFeedback2()}
                />
              </div>
              <div className={styles.line2_mob}>
                {phone != `` &&
                  <div className={styles.phone}>
                    <Image src={`/${assets_path}/images/phone.svg`} alt="P" width={14} height={14} />
                    <div>
                      <a className={styles.phone_link} href={`tel:${phone.replace(/[^\d+]/g, '')}`} rel='nofollow'>{phone}</a>
                      <a className={styles.phone_sitemail} href={`mailto:${sitemail}`} rel='nofollow'>{sitemail}</a>
                    </div>
                  </div>
                }
                {adres &&
                  <div className={styles.adres}>
                    <Image src={`/${assets_path}/images/adres.svg`} alt="0" width={14} height={14} />
                    <div>
                      <div className={styles.adres_name + ` mb-0`}>{adres}</div>
                    </div>
                  </div>
                }
                <div className={styles.social}>
                  {vklink != `` &&
                    <a href={vklink} target='_blank' rel='nofollow'>
                      <Image src={`/${assets_path}/images/vk.svg`} alt="vk" width={35} height={35} />
                    </a>
                  }
                  {youlink != `` &&
                    <a href={youlink} target='_blank' rel='nofollow'>
                      <Image src={`/${assets_path}/images/you.svg`} alt="you" width={35} height={35} />
                    </a>
                  }
                </div>
              </div>
            </Container>
          </div>

          {/* Offcanvas Menu */}
          <Offcanvas show={show_offcanvas} onHide={this.closeOffcanvas} placement="end">
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>Меню</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <div className={styles.offcanvas_menu}>
                {this.renderOffcanvasMenuItems(menu)}
              </div>
            </Offcanvas.Body>
          </Offcanvas>
        </div>
      </>
    )
  }
}

Header.propTypes = {
  logo: PropTypes.string,
  sitename: PropTypes.string,
  slogan: PropTypes.string,
  adres: PropTypes.string,
  phone: PropTypes.string,
  sitemail: PropTypes.string,
  vklink: PropTypes.string,
  youlink: PropTypes.string,
  rutubelink: PropTypes.string,
  marshrut: PropTypes.string,
  assets_path: PropTypes.string,
  menu: PropTypes.array
}

Header.defaultProps = {
  logo: '/assets/images/logo.png',
  sitename: 'GOODWIN',
  slogan: 'Производство и установкадеревянных евроокон',
  adres: 'Нижний Новгород, ул. Белинского, д. 60А',
  phone: '8 (831) 423-29-93',
  sitemail: 'info@goodwin-nnov.ru',
  vklink: '',
  youlink: '',
  rutubelink: '',
  marshrut: '',
  assets_path: 'assets',
  menu: []
}

export default Header